import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yaogan",
  "use": "icon-yaogan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yaogan\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0C352.64 0 224 128.64 224 288c0 137.6 96.64 252.8 225.28 280.96v397.44c0 32 25.6 57.6 57.6 57.6h10.24c32 0 57.6-25.6 57.6-57.6V568.96A287.68 287.68 0 0 0 800 288C800 128.64 671.36 0 512 0zM433.28 298.24c-60.8 0-110.08-49.28-110.08-109.44a110.08 110.08 0 1 1 220.16 0c0 60.16-49.28 109.44-110.08 109.44z\" p-id=\"3426\" fill=\"#13227a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yaogan.svg
// module id = brG5
// module chunks = 252